var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import styled from "styled-components";
import { FlexBox, useToasts } from "@brg/ui";
import { CourseContainer, ThemeBackground, ToolbarDescription } from './style';
import { useUppyLoader } from './components/UppyLoader';
import { HomeworkEdit } from './sections/HomeworkEdit';
import { HomeworkView } from './sections/HomeworkView';
import { LoaderModal } from '../../../../modals/LoaderModal';
import useLocalization from '../../../../../hooks/useLocalization';
import EditorToolbar from '../../editor/EditorToolbar';
import { useDispatch } from 'react-redux';
import urlApi from '../../../../../actions/urlApi';
import { resetHomeWorkAction, sendHomeWorkAction } from '../../../../../actions/homeworkAction';
import { getLongReadPosts } from '../../../../../actions/getLongReadPosts';
import { updateLongReadPost } from '../../../../../actions/updateLongReadPost';
import { useProfile } from '@brg/auth';
import { CaptionBlock } from '../coloredblock';
import { CaptionMarkdownText } from '../whitepostblock';
import CaptionEdit from '../../editor/CaptionEdit';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import formatLinks from '../../../../../utilites/formatLinks';
import useCommonProps from '../../../../../hooks/useCommonProps';
import { uploadValidator } from "../../editor/updateel";
import { MultiHomeworkStartBlock } from './components/MultiHomeworkStartBlock';
import AddBlock from '../../addblock';
export var HOME_WORK_STUDENT_SIGN = 'homework_student';
var DEFAULT_TEXT = '';
var DEFAULT_TYPE = 'image';
var DEFAULT_MAX_IMAGES_COUNT = 10;
var IMAGE_DEFAULT_COUNT = '1';
export var LOADER_TEXT = {
    load: 'courses_load',
    send: 'courses_send',
    create: 'courses_create',
    add: 'courses_add'
};
export var HOME_WORK_TYPES = {
    image: 'image',
    slider: 'slider',
    video: 'video',
    audio: 'audio',
    text: 'text',
    code: 'code',
    default: ''
};
var HomeworkTitleWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n  margin-bottom: 24px;\n"], ["\n  width: 100%;\n  position: relative;\n  margin-bottom: 24px;\n"])));
export var CourseHomeWork = function (props) {
    var _a, _b;
    var post = props.post, longreadId = props.longreadId, themeBlockIdx = props.themeBlockIdx, tempBlock = props.tempBlock, isTeacher = props.isTeacher, _c = props.uploadedHomeworksCount, uploadedHomeworksCount = _c === void 0 ? 0 : _c, _d = props.submitDisabled, submitDisabled = _d === void 0 ? false : _d, setActiveUploader = props.setActiveUploader;
    var t = useLocalization().t;
    var dispatch = useDispatch();
    var profile = useProfile();
    var toasts = useToasts();
    var fileRef = useRef();
    var _e = useCommonProps(), projectId = _e.projectId, sign = _e.sign, isLMS = _e.isLMS, lmsModuleInfo = _e.lmsModuleInfo;
    var _f = useState([]), files = _f[0], setFiles = _f[1];
    var _g = useState([]), images = _g[0], setImages = _g[1];
    var _h = useState(''), esseText = _h[0], setEsseText = _h[1];
    var _j = useState(''), imageTextPosition = _j[0], setImageTextPosition = _j[1];
    var _k = useState(''), imageText = _k[0], setImageText = _k[1];
    var _l = useState(''), imageCaption = _l[0], setImageCaption = _l[1];
    var _m = useState(false), editingCaption = _m[0], setEditingCaption = _m[1];
    var _o = useState(Date.now()), time = _o[0], setTime = _o[1];
    var _p = useState(false), showLoader = _p[0], setShowLoader = _p[1];
    var _q = useState(false), isAddingHomework = _q[0], setIsAddingHomework = _q[1];
    var _r = useState(''), multiLoadCaptionMode = _r[0], setMultiLoadCaptionMode = _r[1];
    var _s = useState(''), textPosition = _s[0], setTextPosition = _s[1];
    var _t = useState(null), controlPlacer = _t[0], setControlPlacer = _t[1];
    var _u = useState(LOADER_TEXT.load), loaderText = _u[0], setLoaderText = _u[1];
    var _v = useState({
        text: DEFAULT_TEXT,
        types: [DEFAULT_TYPE],
        maxCount: DEFAULT_MAX_IMAGES_COUNT,
        nominationType: '0',
        homeWorkWeight: '1',
        groupId: ''
    }), values = _v[0], setValues = _v[1];
    var _w = useState(false), showUploader = _w[0], setShowUploader = _w[1];
    var _x = useState(false), showAddblock = _x[0], setShowAddblock = _x[1];
    var _y = useState([]), selectedTypes = _y[0], setSelectedTypes = _y[1];
    var isStudentPost = useMemo(function () { var _a; return !!((_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'student_id'; })); }, [post]);
    if (!isTeacher && !((_b = (_a = lmsModuleInfo === null || lmsModuleInfo === void 0 ? void 0 : lmsModuleInfo.themeInfos) === null || _a === void 0 ? void 0 : _a.find(function (theme) { return theme.longreadId === (post === null || post === void 0 ? void 0 : post.longreadId); })) === null || _b === void 0 ? void 0 : _b.needHomeWork)) {
        return null;
    }
    var onUploadComplete = useCallback(function (uploadComplete) {
        if (uploadComplete) {
            setFiles([]);
        }
    }, []);
    var _z = useUppyLoader(files, fileRef, onUploadComplete, time), uppy = _z[0], data = _z[1];
    var count = useMemo(function () { var _a; return ((_a = post === null || post === void 0 ? void 0 : post.attachments) === null || _a === void 0 ? void 0 : _a.length) + (data === null || data === void 0 ? void 0 : data.length); }, [post, data]);
    var isLoading = useMemo(function () { return (!!(files === null || files === void 0 ? void 0 : files.length)); }, [files]);
    var isSlider = useMemo(function () { return values === null || values === void 0 ? void 0 : values.types.includes(HOME_WORK_TYPES.slider); }, [values]);
    useEffect(function () {
        if (setActiveUploader && (post === null || post === void 0 ? void 0 : post.postId)) {
            setActiveUploader(showAddblock);
        }
    }, [setActiveUploader, post === null || post === void 0 ? void 0 : post.postId, showAddblock]);
    useEffect(function () {
        if (data === null || data === void 0 ? void 0 : data.length) {
            setImages(data === null || data === void 0 ? void 0 : data.reduce(function (a, v) { return __spreadArray(__spreadArray([], a, true), [__assign(__assign({}, v), { isUploaded: true, caption: '', text: '', isCaptionSetted: false, isTextSetted: false })], false); }, []));
            setTime(Date.now());
        }
    }, [data]);
    useEffect(function () {
        if (multiLoadCaptionMode !== '') {
        }
    }, [multiLoadCaptionMode]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (post && ((_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.length)) {
            var text = (_c = (_b = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _b === void 0 ? void 0 : _b.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'text'; })) === null || _c === void 0 ? void 0 : _c.value;
            var types = (_e = (_d = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _d === void 0 ? void 0 : _d.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'hm_type'; })) === null || _e === void 0 ? void 0 : _e.value;
            if (types) {
                if (Array.isArray(types)) {
                    // ok
                }
                else if (typeof types === 'string' && types.includes(',')) {
                    types = types.split(',');
                }
                else if (typeof types === 'string') {
                    types = [types];
                }
            }
            else {
                types = [DEFAULT_TYPE];
            }
            var maxCount = Number((_g = (_f = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _f === void 0 ? void 0 : _f.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'maxCount'; })) === null || _g === void 0 ? void 0 : _g.value);
            var nominationType = Number((_j = (_h = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _h === void 0 ? void 0 : _h.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'nominationType'; })) === null || _j === void 0 ? void 0 : _j.value);
            var homeWorkWeight = ((_l = (_k = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _k === void 0 ? void 0 : _k.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'homeWorkWeight'; })) === null || _l === void 0 ? void 0 : _l.value) || '1';
            var groupId = ((_o = (_m = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _m === void 0 ? void 0 : _m.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'groupId'; })) === null || _o === void 0 ? void 0 : _o.value) || '';
            setValues({
                text: text,
                types: types,
                maxCount: maxCount,
                nominationType: nominationType,
                homeWorkWeight: homeWorkWeight,
                groupId: groupId
            });
        }
    }, [post]);
    var handleDataChange = useCallback(function (name, value) {
        setValues(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
    }, [setValues]);
    var onToggleLoader = function (text) {
        if (text) {
            setLoaderText(text);
        }
        setShowLoader(true);
        setTimeout(function () { return setShowLoader(false); }, 1500);
    };
    var onAddImage = useCallback(function (e, isAdditionalLoad) { return __awaiter(void 0, void 0, void 0, function () {
        var newFiles, multipleFilesCheckResult, allowed, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    newFiles = Array.from(e.target.files);
                    multipleFilesCheckResult = [];
                    if (!((newFiles === null || newFiles === void 0 ? void 0 : newFiles.length) > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(newFiles.map(function (img) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, uploadValidator({
                                            files: [img],
                                            toasts: toasts,
                                            isWideImageType: false,
                                            profile: profile,
                                            isLMS: isLMS
                                        })];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); }))];
                case 1:
                    multipleFilesCheckResult = _b.sent();
                    _b.label = 2;
                case 2:
                    if (!((files === null || files === void 0 ? void 0 : files.length) > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, uploadValidator({
                            files: files,
                            toasts: toasts,
                            isWideImageType: false,
                            profile: profile,
                            isLMS: isLMS
                        })];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _a = true;
                    _b.label = 5;
                case 5:
                    allowed = _a;
                    if (!allowed || (multipleFilesCheckResult === null || multipleFilesCheckResult === void 0 ? void 0 : multipleFilesCheckResult.includes(false))) {
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    setTime(Date.now());
                    setTimeout(function () {
                        setFiles(isAdditionalLoad ? __spreadArray(__spreadArray([], files, true), newFiles, true) : newFiles);
                        onToggleLoader(LOADER_TEXT.add);
                    }, 0);
                    return [2 /*return*/];
            }
        });
    }); }, [values, toasts, t, images, profile, files]);
    var onTextChange = useCallback(function (id, value, mode) {
        setImages(images === null || images === void 0 ? void 0 : images.map(function (img) {
            var _a;
            if ((img === null || img === void 0 ? void 0 : img.id) === id) {
                return __assign(__assign({}, img), (_a = {}, _a[mode] = value, _a.isCaptionSetted = mode === 'caption', _a.isTextSetted = mode === 'text', _a));
            }
            return img;
        }));
    }, [images]);
    var onEsseText = useCallback(function (value) {
        setEsseText(value);
    }, [esseText]);
    var onImageTextChange = useCallback(function (ev) {
        setImageText(ev.target.value);
    }, []);
    var onSliderTextChange = useCallback(function (text, position) {
        setImageText(text);
        setImageTextPosition(position);
    }, []);
    var onImageRemove = useCallback(function (fileId) {
        var _a;
        if (isSlider) {
            var fileName_1 = ((_a = images === null || images === void 0 ? void 0 : images.find(function (_a) {
                var id = _a.id;
                return id === fileId;
            })) === null || _a === void 0 ? void 0 : _a.name) || '';
            setFiles(files === null || files === void 0 ? void 0 : files.filter(function (_a) {
                var name = _a.name;
                return name !== fileName_1;
            }));
        }
        setImages(images === null || images === void 0 ? void 0 : images.filter(function (_a) {
            var id = _a.id;
            return id !== fileId;
        }));
    }, [images, files, isSlider]);
    var onSetSortedImg = useCallback(function (list) {
        setImages(__spreadArray([], list, true));
    }, []);
    var onChooseType = useCallback(function (type) {
        setValues(function (prev) {
            if (values.maxCount === 1) {
                return __assign(__assign({}, prev), { types: prev.types[0] === type ? [] : [type] });
            }
            else {
                return __assign(__assign({}, prev), { types: prev.types.includes(type)
                        ? prev.types.filter(function (t) { return t !== type; })
                        : __spreadArray(__spreadArray([], prev.types, true), [type], false) });
            }
        });
    }, [values]);
    var onSystemType = useCallback(function (_a) {
        var label = _a.label, value = _a.value;
        if (values.nominationType === value)
            return;
        handleDataChange('nominationType', value);
    }, [values, handleDataChange]);
    var onWeightChange = useCallback(function (_a) {
        var label = _a.label, value = _a.value;
        if (values.homeWorkWeight === value)
            return;
        handleDataChange('homeWorkWeight', value);
    }, [values, handleDataChange]);
    var onGroupChange = useCallback(function (_a) {
        var label = _a.label, value = _a.value;
        if (values.groupId === value)
            return;
        handleDataChange('groupId', value);
    }, [values, handleDataChange]);
    var onHeaderChange = useCallback(function (text) {
        handleDataChange('text', text);
    }, [values]);
    var onAddText = useCallback(function (value) {
        setImageTextPosition(value);
        if (imageCaption) {
            setImageText(imageCaption);
        }
        setEditingCaption(false);
    }, [setImageTextPosition]);
    var onAddCaption = useCallback(function (value) {
        setImageCaption(value);
        setEditingCaption(false);
        setImageTextPosition('caption-bottom');
    }, [setEditingCaption, setImageTextPosition, setImageCaption]);
    var onToggleCaption = useCallback(function () {
        setEditingCaption(!editingCaption);
        setMultiLoadCaptionMode('small');
        if (imageText) {
            setImageCaption(imageText);
        }
        setImageText('');
        if (!editingCaption)
            setImageTextPosition('caption-bottom');
    }, [editingCaption]);
    var onCancel = useCallback(function () {
        setFiles([]);
        setImages([]);
        setTime(Date.now());
        setIsAddingHomework(false);
        setImageTextPosition('');
        setImageCaption('');
    }, []);
    var onCountChange = useCallback(function (count) {
        handleDataChange('maxCount', count);
    }, [values]);
    var onSlideTextChange = useCallback(function (id, text, textPosition) {
        var index = images === null || images === void 0 ? void 0 : images.findIndex(function (i) { return [i === null || i === void 0 ? void 0 : i.id, i === null || i === void 0 ? void 0 : i.postAttachmentId].includes(id); });
        var newArray = __spreadArray([], images, true);
        newArray[index] = __assign(__assign({}, newArray[index]), { text: text, textPosition: textPosition });
        setImages(newArray);
    }, [images]);
    var onAddNewPost = useCallback(function (isHomeWorkTeacherBlock) {
        var _a, _b, _c, _d, _e, _f;
        var requestData;
        var computeState = [
            { 'name': 'text', 'value': values === null || values === void 0 ? void 0 : values.text },
            { 'name': 'hm_type', 'value': values === null || values === void 0 ? void 0 : values.types.join(',') },
            { 'name': 'maxCount', 'value': ((values === null || values === void 0 ? void 0 : values.types.includes(DEFAULT_TYPE)) && (values === null || values === void 0 ? void 0 : values.types) === 1) ? IMAGE_DEFAULT_COUNT : values === null || values === void 0 ? void 0 : values.maxCount.toString() },
            { 'name': 'nominationType', 'value': (_c = (_b = (_a = values === null || values === void 0 ? void 0 : values.nominationType) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : '' },
            { 'name': 'homeWorkWeight', 'value': (_f = (_e = (_d = values === null || values === void 0 ? void 0 : values.homeWorkWeight) === null || _d === void 0 ? void 0 : _d.toString) === null || _e === void 0 ? void 0 : _e.call(_d)) !== null && _f !== void 0 ? _f : '1' },
            { 'name': 'groupId', 'value': (values === null || values === void 0 ? void 0 : values.groupId) || '' },
            { 'name': 'isMulti', value: Number(values.maxCount) > 1 ? '1' : '0' }
        ];
        if (isHomeWorkTeacherBlock) {
            requestData = __assign(__assign({}, post), { additionalInfo: computeState });
            dispatch(updateLongReadPost('', requestData));
        }
        if (tempBlock) {
            requestData = __assign(__assign({}, tempBlock), { additionalInfo: computeState });
            dispatch(updateLongReadPost('', requestData));
        }
        else {
            requestData = {
                id: null,
                title: '',
                text: '',
                color: 'light',
                imageid: '',
                lgid: longreadId,
                isFL: '',
                imgCaption: '',
                style: HOME_WORK_STUDENT_SIGN,
                num: (post === null || post === void 0 ? void 0 : post.position) + 1,
                imageData: [],
                thematic: '',
                titlePosition: '',
                projectIds: [],
                formId: '',
                formPosition: '',
                anchorText: '',
                buttons: [],
                additionalInfo: computeState
            };
            dispatch(sendHomeWorkAction(requestData));
        }
        onToggleLoader(LOADER_TEXT.create);
        setTimeout(function () {
            toasts.info(t('lms.homework.task_added'));
            dispatch(getLongReadPosts('', longreadId, sign));
            dispatch(resetHomeWorkAction());
        }, 1500);
    }, [tempBlock, values.types, values.maxCount, values.text, values.nominationType, values.homeWorkWeight, values.groupId]);
    var attachments = useMemo(function () {
        var files = [];
        if ((images === null || images === void 0 ? void 0 : images.length) === 0 || values.types.length === 0) {
            files = [];
        }
        if ((values.types.includes('slider') || values.types.includes('image')) && (images === null || images === void 0 ? void 0 : images.length)) {
            files = images === null || images === void 0 ? void 0 : images.map(function (item) {
                return {
                    text: (item === null || item === void 0 ? void 0 : item.text) || '',
                    textPosition: (item === null || item === void 0 ? void 0 : item.textPosition) || '',
                    description: (item === null || item === void 0 ? void 0 : item.caption) || '',
                    isDeleted: true,
                    postAttachmentId: '',
                    referenceId: '',
                    nominationType: '0',
                    type: 0,
                    file: {
                        fileId: "".concat(item.url),
                        containerId: 'string',
                        isNew: true,
                        type: 'string',
                        // url: data?.src,
                        url: 'string',
                        size: 'string',
                        localization: 'string'
                    }
                };
            });
        }
        return files;
    }, [images, values.types]);
    var SaveHomeWork = useCallback(function (blockType) {
        var _a;
        setIsAddingHomework(true);
        var isMultiple = (attachments === null || attachments === void 0 ? void 0 : attachments.length) > 1 && blockType === HOME_WORK_TYPES.image;
        var isSlider = blockType === HOME_WORK_TYPES.slider;
        var isImg = blockType === HOME_WORK_TYPES.image;
        var imageid = (blockType === HOME_WORK_TYPES.image && (images === null || images === void 0 ? void 0 : images.length) === 1) ? (_a = images === null || images === void 0 ? void 0 : images[0]) === null || _a === void 0 ? void 0 : _a.url : '';
        var baseInfo = isStudentPost ? post.additionalInfo : __spreadArray(__spreadArray([], post.additionalInfo, true), [
            { name: 'student_id', value: (profile === null || profile === void 0 ? void 0 : profile.accountId) || '' },
            { name: 'additionalType', value: 'student_homework' },
            { name: 'projectId', value: projectId }
        ], false);
        var filteredInfo = baseInfo.filter(function (item) { return item.name !== 'hm_type'; });
        var additionalInfo = __spreadArray(__spreadArray([
            { name: 'hm_type', value: blockType }
        ], filteredInfo, true), (Number(values.maxCount) > 1 ? [{ name: 'isMulti', value: '1' }] : []), true);
        var requestData = __assign(__assign(__assign(__assign({}, post), { attachments: attachments, imageid: imageid, lgid: longreadId }), (!isMultiple && { caption: imageCaption, text: imageText, titlePosition: imageTextPosition || 'bottom' })), { style: blockType, num: themeBlockIdx + 1, imageList: images, text: isImg ? imageText : esseText, additionalInfo: additionalInfo });
        var onSuccess = function () {
            setTimeout(function () {
                toasts.info(t('lms.homework.task_went_to_check'));
                onCancel();
                setIsAddingHomework(false);
                dispatch(getLongReadPosts('', longreadId, sign));
                dispatch(resetHomeWorkAction());
            }, 1500);
        };
        var onError = function () {
            setIsAddingHomework(false);
            toasts.info(t('lms.homework.something_went_wrong'));
        };
        urlApi().addNewHomeWorkPost(requestData, isMultiple, isSlider, onSuccess, onError);
        onToggleLoader(LOADER_TEXT.send);
    }, [
        images,
        post,
        attachments,
        profile,
        imageCaption,
        imageText,
        isStudentPost,
        longreadId,
        projectId,
        themeBlockIdx,
        esseText,
        selectedTypes
    ]);
    var handlers = useMemo(function () { return ({
        onAddImage: onAddImage,
        onImageRemove: onImageRemove,
        onChooseType: onChooseType,
        onHeaderChange: onHeaderChange,
        onSystemType: onSystemType,
        onWeightChange: onWeightChange,
        onGroupChange: onGroupChange,
        onCountChange: onCountChange,
        onSetSortedImg: onSetSortedImg,
        onAddNewPost: onAddNewPost,
        SaveHomeWork: SaveHomeWork,
        onTextChange: onTextChange,
        onImageTextChange: onImageTextChange,
        onAddText: onAddText,
        onEsseText: onEsseText,
        onSlideTextChange: onSlideTextChange,
        onSliderTextChange: onSliderTextChange,
    }); }, [
        onImageRemove,
        onAddImage,
        onChooseType,
        onHeaderChange,
        onSystemType,
        onWeightChange,
        onGroupChange,
        onCountChange,
        onSetSortedImg,
        onAddNewPost,
        SaveHomeWork,
        onTextChange,
        onImageTextChange,
        onSlideTextChange,
        onEsseText
    ]);
    var isTop = useMemo(function () {
        if (values.maxCount === 1) {
            return ((values.types[0] === HOME_WORK_TYPES.slider || values.types[0] === HOME_WORK_TYPES.image) &&
                !!(images === null || images === void 0 ? void 0 : images.length));
        }
        else if (values.maxCount > 1) {
            return ((selectedTypes.includes(HOME_WORK_TYPES.slider) || selectedTypes.includes(HOME_WORK_TYPES.image)) &&
                !!(images === null || images === void 0 ? void 0 : images.length));
        }
        return false;
    }, [values.types, images, selectedTypes]);
    var computeType = useMemo(function () { return ((values.types.includes(HOME_WORK_TYPES.image) && (images === null || images === void 0 ? void 0 : images.length) === 1) ? 'big' :
        (values.types.includes(HOME_WORK_TYPES.image) && (images === null || images === void 0 ? void 0 : images.length) > 1) ? 'multiple' : values.types.join(',')); }, [values.types, images]);
    var postDisabled = useMemo(function () {
        if (isAddingHomework)
            return true;
        var isImage = values.types.includes(HOME_WORK_TYPES.image);
        var isSlider = values.types.includes(HOME_WORK_TYPES.slider);
        if ((isImage || isSlider) && (images === null || images === void 0 ? void 0 : images.length) > 0) {
            return false;
        }
        return true;
    }, [images, isLoading, values, isAddingHomework]);
    var hideBackground = useMemo(function () { return (!isTeacher && imageTextPosition === 'caption-bottom' && !!(images === null || images === void 0 ? void 0 : images.length)); }, [imageTextPosition, isTeacher]);
    var editorToolbar = useCallback(function (type) {
        var _a;
        return (React.createElement(React.Fragment, null, isTeacher ? (React.createElement(EditorToolbar, { isLMSHomework: true, onSubmit: function () { return onAddNewPost(true); }, postBtnText: t('editor.courses.post-btn-text'), style: 'teacher-block' })) : !!(images === null || images === void 0 ? void 0 : images.length) && (React.createElement(EditorToolbar, __assign({ isLMSHomework: true, onSubmit: function () { return SaveHomeWork(type || values.types[0]); }, onAddImage: onAddImage, position: 'top', onAddText: onAddText }, ((_a = [values.types.includes(HOME_WORK_TYPES.slider)]) === null || _a === void 0 ? void 0 : _a.includes(values.types.join(','))) && { onAddSlider: function (e) { return onAddImage(e, true); } }, { onAddCaption: onToggleCaption, editingCaption: editingCaption || imageTextPosition === 'caption-bottom', postDisabled: postDisabled, fileRef: fileRef, postTextPos: imageTextPosition, multiLoadCaptionMode: multiLoadCaptionMode, style: computeType, onToggleMultiCaption: setMultiLoadCaptionMode, postBtnText: t('editor.courses.post-btn-text'), onClose: onCancel, setSliderControlsPlacer: function () {
                var sliderControlsPlacer = document.querySelector('#slider-controls-portal');
                setControlPlacer(sliderControlsPlacer);
            } })))));
    }, [
        onAddNewPost,
        SaveHomeWork,
        onAddImage,
        onAddText,
        onToggleCaption,
        onAddCaption,
        t,
        editingCaption,
        imageTextPosition,
        postDisabled,
        multiLoadCaptionMode,
        values,
        computeType,
        images,
        isTeacher,
        onCancel
    ]);
    var handleChooseType = useCallback(function (type) {
        setSelectedTypes(function (prev) { return __spreadArray(__spreadArray([], prev, true), [type], false); });
        setShowUploader(false);
        setShowAddblock(true);
    }, []);
    var handleResetType = useCallback(function () {
        setSelectedTypes([]);
        setShowUploader(true);
        setShowAddblock(false);
        setEsseText('');
    }, []);
    var handleToolbarClose = useCallback(function () {
        setShowUploader(false);
        setSelectedTypes([]);
    }, []);
    var handleStartUpload = useCallback(function () {
        setShowUploader(true);
    }, []);
    var handleAddBlockClick = useCallback(function () {
        if (uploadedHomeworksCount < values.maxCount) {
            setShowUploader(true);
            setShowAddblock(false);
        }
    }, [selectedTypes, values.maxCount, uploadedHomeworksCount]);
    var standartHomeworkRender = useMemo(function () {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement(ThemeBackground, { hideBackground: hideBackground },
                showLoader && React.createElement(LoaderModal, { placeholder: t("modal.loader.".concat(loaderText)) }),
                isTop && editorToolbar(values.types[0]),
                editingCaption && [HOME_WORK_TYPES.slider, HOME_WORK_TYPES.image].includes(values.types[0]) && (React.createElement(CaptionEdit, { value: imageCaption, onSubmit: function (value) { return onAddCaption(value); }, onCancel: function () { return setEditingCaption(false); } })),
                React.createElement(CourseContainer, { hidePadding: files === null || files === void 0 ? void 0 : files.length, isOwner: isTeacher }, isTeacher
                    ? React.createElement(HomeworkEdit, __assign({ text: values.text, types: values.types, count: values.maxCount, onToggleType: onChooseType, nominationType: values.nominationType, homeWorkWeight: values.homeWorkWeight, groupId: values.groupId }, handlers))
                    : React.createElement(HomeworkView, __assign({ post: post, uppy: uppy, text: values.text, imageTextPosition: imageTextPosition, imageText: imageText, textPosition: textPosition, fileRef: fileRef, count: count, maxCount: values.maxCount, src: images, types: values.types[0], isLoading: isLoading, captionMode: multiLoadCaptionMode, controlPlacer: controlPlacer, imageCaption: imageCaption, onClose: !isTeacher ? handleResetType : undefined }, handlers, { SaveHomeWork: function () { return SaveHomeWork(values.types[0]); } }))),
                !isTop && editorToolbar(values.types[0]),
                imageCaption && !((_a = ['top', 'center', 'bottom']) === null || _a === void 0 ? void 0 : _a.includes(imageTextPosition)) && (React.createElement(CaptionBlock, { colorStyle: isTeacher ? 'white' : 'lms' },
                    React.createElement(CaptionMarkdownText, { rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks(imageCaption)))))));
    }, [isTeacher, showUploader, values.types, selectedTypes, showAddblock, hideBackground, showLoader, post, images, isLoading, onAddNewPost,
        SaveHomeWork,
        onAddImage,
        onAddText,
        onToggleCaption,
        onAddCaption, handleResetType, isTop]);
    var multiHomeworkRender = useMemo(function () {
        var _a;
        return (React.createElement(React.Fragment, null,
            !isTeacher && !showUploader && values.maxCount > 1 && values.maxCount !== uploadedHomeworksCount && !selectedTypes.length && !submitDisabled && (React.createElement(MultiHomeworkStartBlock, { onStart: handleStartUpload })),
            (!isTeacher && selectedTypes.length > 0) ? (React.createElement(React.Fragment, null,
                selectedTypes.map(function (type, idx) {
                    var _a;
                    return (React.createElement("div", { key: idx, style: { marginBottom: idx !== selectedTypes.length - 1 ? 24 : 0 } },
                        React.createElement(ThemeBackground, { hideBackground: hideBackground },
                            showLoader && React.createElement(LoaderModal, { placeholder: t("modal.loader.".concat(loaderText)) }),
                            isTop && (type === HOME_WORK_TYPES.slider || type === HOME_WORK_TYPES.image) && editorToolbar(type),
                            editingCaption && (values.types.includes(HOME_WORK_TYPES.slider) || values.types.includes(HOME_WORK_TYPES.image)) && (React.createElement(CaptionEdit, { value: imageCaption, onSubmit: function (value) { return onAddCaption(value); }, onCancel: function () { return setEditingCaption(false); } })),
                            React.createElement(CourseContainer, { hidePadding: (files === null || files === void 0 ? void 0 : files.length) && (type === HOME_WORK_TYPES.slider || type === HOME_WORK_TYPES.image), isOwner: isTeacher },
                                React.createElement(HomeworkView, __assign({ post: post, uppy: uppy, text: values.text, imageTextPosition: imageTextPosition, imageText: imageText, textPosition: textPosition, fileRef: fileRef, count: count, maxCount: values.maxCount, src: images, types: [type], isLoading: isLoading, captionMode: multiLoadCaptionMode, controlPlacer: controlPlacer, imageCaption: imageCaption, onClose: handleResetType }, handlers, { SaveHomeWork: function () { return SaveHomeWork(type); } }))),
                            imageCaption && !((_a = ['top', 'center', 'bottom']) === null || _a === void 0 ? void 0 : _a.includes(imageTextPosition)) && (React.createElement(CaptionBlock, { colorStyle: isTeacher ? 'white' : 'lms' },
                                React.createElement(CaptionMarkdownText, { rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks(imageCaption)))))));
                }),
                false && ((selectedTypes.length + uploadedHomeworksCount) < values.maxCount) &&
                    React.createElement(AddBlock, { colorStyle: 'light', blockNum: selectedTypes.length, blocksLength: selectedTypes.length + 1, hideBottomAdd: true, hideTopAdd: false, theme: null, onClick: handleAddBlockClick }))) : (React.createElement(ThemeBackground, { hideBackground: hideBackground },
                showLoader && React.createElement(LoaderModal, { placeholder: t("modal.loader.".concat(loaderText)) }),
                isTop && editorToolbar(values.types[0]),
                editingCaption && values.types.includes(HOME_WORK_TYPES.slider) && (React.createElement(CaptionEdit, { value: imageCaption, onSubmit: function (value) { return onAddCaption(value); }, onCancel: function () { return setEditingCaption(false); } })),
                isTeacher
                    ? React.createElement(CourseContainer, { hidePadding: files === null || files === void 0 ? void 0 : files.length, isOwner: isTeacher },
                        React.createElement(HomeworkEdit, __assign({ text: values.text, types: values.types, count: values.maxCount, nominationType: values.nominationType, homeWorkWeight: values.homeWorkWeight, groupId: values.groupId, onToggleType: onChooseType }, handlers)))
                    : null,
                !isTop && editorToolbar(selectedTypes),
                imageCaption && !((_a = ['top', 'center', 'bottom']) === null || _a === void 0 ? void 0 : _a.includes(imageTextPosition)) && (React.createElement(CaptionBlock, { colorStyle: isTeacher ? 'white' : 'lms' },
                    React.createElement(CaptionMarkdownText, { rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks(imageCaption)))))),
            !isTeacher && showUploader && (React.createElement(FlexBox, { offsetBottom: 24, direction: 'column' },
                React.createElement(ToolbarDescription, null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0431\u043B\u043E\u043A\u0430"),
                React.createElement(EditorToolbar, { style: values.types.join(','), isLMSHomework: true, onChooseType: handleChooseType, selectedTypes: selectedTypes, postBtnText: t('editor.courses.post-btn-text'), onClose: handleToolbarClose })))));
    }, [isTeacher, showUploader, values.types, selectedTypes, showAddblock, hideBackground, showLoader, post, images, isLoading, onAddNewPost,
        SaveHomeWork,
        onAddImage,
        onAddText,
        uploadedHomeworksCount,
        onToggleCaption,
        onAddCaption, handleResetType, isTop]);
    return (React.createElement(React.Fragment, null, values.maxCount === 1 ? standartHomeworkRender : multiHomeworkRender));
};
var templateObject_1;
//# sourceMappingURL=courseHomeWork.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import styled from "styled-components";
import { FlexBox, useToasts } from "@brg/ui";
import { CourseContainer, ThemeBackground, ToolbarDescription } from './style';
import { useUppyLoader } from './components/UppyLoader';
import { HomeworkEdit } from './sections/HomeworkEdit';
import { HomeworkView } from './sections/HomeworkView';
import { LoaderModal } from '../../../../modals/LoaderModal';
import useLocalization from '../../../../../hooks/useLocalization';
import EditorToolbar from '../../editor/EditorToolbar';
import { useDispatch } from 'react-redux';
import urlApi from '../../../../../actions/urlApi';
import { resetHomeWorkAction, sendHomeWorkAction } from '../../../../../actions/homeworkAction';
import { getLongReadPosts } from '../../../../../actions/getLongReadPosts';
import { updateLongReadPost } from '../../../../../actions/updateLongReadPost';
import { useProfile } from '@brg/auth';
import { CaptionBlock } from '../coloredblock';
import { CaptionMarkdownText } from '../whitepostblock';
import CaptionEdit from '../../editor/CaptionEdit';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import formatLinks from '../../../../../utilites/formatLinks';
import useCommonProps from '../../../../../hooks/useCommonProps';
import { uploadValidator } from "../../editor/updateel";
import { MultiHomeworkStartBlock } from './components/MultiHomeworkStartBlock';
import AddBlock from '../../addblock';
export var HOME_WORK_STUDENT_SIGN = 'homework_student';
var DEFAULT_TEXT = '';
var DEFAULT_TYPE = 'image';
var DEFAULT_MAX_IMAGES_COUNT = 10;
var IMAGE_DEFAULT_COUNT = '1';
export var LOADER_TEXT = {
    load: 'courses_load',
    send: 'courses_send',
    create: 'courses_create',
    add: 'courses_add'
};
export var HOME_WORK_TYPES = {
    image: 'image',
    slider: 'slider',
    video: 'video',
    audio: 'audio',
    text: 'text',
    code: 'code',
    default: ''
};
var HomeworkTitleWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n  margin-bottom: 24px;\n"], ["\n  width: 100%;\n  position: relative;\n  margin-bottom: 24px;\n"])));
export var CourseHomeWork = function (props) {
    var _a, _b;
    var post = props.post, longreadId = props.longreadId, themeBlockIdx = props.themeBlockIdx, tempBlock = props.tempBlock, isTeacher = props.isTeacher, _c = props.uploadedHomeworksCount, uploadedHomeworksCount = _c === void 0 ? 0 : _c, _d = props.submitDisabled, submitDisabled = _d === void 0 ? false : _d, setActiveUploader = props.setActiveUploader;
    var t = useLocalization().t;
    var dispatch = useDispatch();
    var profile = useProfile();
    var toasts = useToasts();
    var fileRef = useRef();
    var _e = useCommonProps(), projectId = _e.projectId, sign = _e.sign, isLMS = _e.isLMS, lmsModuleInfo = _e.lmsModuleInfo;
    var _f = useState([]), files = _f[0], setFiles = _f[1];
    var _g = useState([]), images = _g[0], setImages = _g[1];
    var _h = useState(''), esseText = _h[0], setEsseText = _h[1];
    var _j = useState(''), imageTextPosition = _j[0], setImageTextPosition = _j[1];
    var _k = useState(''), imageText = _k[0], setImageText = _k[1];
    var _l = useState(''), imageCaption = _l[0], setImageCaption = _l[1];
    var _m = useState(false), editingCaption = _m[0], setEditingCaption = _m[1];
    var _o = useState(Date.now()), time = _o[0], setTime = _o[1];
    var _p = useState(false), showLoader = _p[0], setShowLoader = _p[1];
    var _q = useState(false), isAddingHomework = _q[0], setIsAddingHomework = _q[1];
    var _r = useState(''), multiLoadCaptionMode = _r[0], setMultiLoadCaptionMode = _r[1];
    var _s = useState(''), textPosition = _s[0], setTextPosition = _s[1];
    var _t = useState(null), controlPlacer = _t[0], setControlPlacer = _t[1];
    var _u = useState(LOADER_TEXT.load), loaderText = _u[0], setLoaderText = _u[1];
    var _v = useState({
        text: DEFAULT_TEXT,
        types: [DEFAULT_TYPE],
        maxCount: DEFAULT_MAX_IMAGES_COUNT,
        nominationType: '0',
        homeWorkWeight: '1',
        groupId: ''
    }), values = _v[0], setValues = _v[1];
    var _w = useState(false), showUploader = _w[0], setShowUploader = _w[1];
    var _x = useState(false), showAddblock = _x[0], setShowAddblock = _x[1];
    var _y = useState([]), selectedTypes = _y[0], setSelectedTypes = _y[1];
    var isStudentPost = useMemo(function () { var _a; return !!((_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'student_id'; })); }, [post]);
    if (!isTeacher && !((_b = (_a = lmsModuleInfo === null || lmsModuleInfo === void 0 ? void 0 : lmsModuleInfo.themeInfos) === null || _a === void 0 ? void 0 : _a.find(function (theme) { return theme.longreadId === (post === null || post === void 0 ? void 0 : post.longreadId); })) === null || _b === void 0 ? void 0 : _b.needHomeWork)) {
        return null;
    }
    var onUploadComplete = useCallback(function (uploadComplete) {
        if (uploadComplete) {
            setFiles([]);
        }
    }, []);
    var _z = useUppyLoader(files, fileRef, onUploadComplete, time), uppy = _z[0], data = _z[1];
    var count = useMemo(function () { var _a; return ((_a = post === null || post === void 0 ? void 0 : post.attachments) === null || _a === void 0 ? void 0 : _a.length) + (data === null || data === void 0 ? void 0 : data.length); }, [post, data]);
    var isLoading = useMemo(function () { return (!!(files === null || files === void 0 ? void 0 : files.length)); }, [files]);
    var isSlider = useMemo(function () { return values === null || values === void 0 ? void 0 : values.types.includes(HOME_WORK_TYPES.slider); }, [values]);
    useEffect(function () {
        if (setActiveUploader && (post === null || post === void 0 ? void 0 : post.postId)) {
            setActiveUploader(showAddblock);
        }
    }, [setActiveUploader, post === null || post === void 0 ? void 0 : post.postId, showAddblock]);
    useEffect(function () {
        if (data === null || data === void 0 ? void 0 : data.length) {
            setImages(data === null || data === void 0 ? void 0 : data.reduce(function (a, v) { return __spreadArray(__spreadArray([], a, true), [__assign(__assign({}, v), { isUploaded: true, caption: '', text: '', isCaptionSetted: false, isTextSetted: false })], false); }, []));
            setTime(Date.now());
        }
    }, [data]);
    useEffect(function () {
        if (multiLoadCaptionMode !== '') {
        }
    }, [multiLoadCaptionMode]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (post && ((_a = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _a === void 0 ? void 0 : _a.length)) {
            var text = (_c = (_b = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _b === void 0 ? void 0 : _b.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'text'; })) === null || _c === void 0 ? void 0 : _c.value;
            var types = (_e = (_d = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _d === void 0 ? void 0 : _d.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'hm_type'; })) === null || _e === void 0 ? void 0 : _e.value;
            if (types) {
                if (Array.isArray(types)) {
                    // ok
                }
                else if (typeof types === 'string' && types.includes(',')) {
                    types = types.split(',');
                }
                else if (typeof types === 'string') {
                    types = [types];
                }
            }
            else {
                types = [DEFAULT_TYPE];
            }
            var maxCount = Number((_g = (_f = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _f === void 0 ? void 0 : _f.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'maxCount'; })) === null || _g === void 0 ? void 0 : _g.value);
            var nominationType = Number((_j = (_h = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _h === void 0 ? void 0 : _h.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'nominationType'; })) === null || _j === void 0 ? void 0 : _j.value);
            var homeWorkWeight = ((_l = (_k = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _k === void 0 ? void 0 : _k.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'homeWorkWeight'; })) === null || _l === void 0 ? void 0 : _l.value) || '1';
            var groupId = ((_o = (_m = post === null || post === void 0 ? void 0 : post.additionalInfo) === null || _m === void 0 ? void 0 : _m.find(function (data) { return (data === null || data === void 0 ? void 0 : data.name) === 'groupId'; })) === null || _o === void 0 ? void 0 : _o.value) || '';
            setValues({
                text: text,
                types: types,
                maxCount: maxCount,
                nominationType: nominationType,
                homeWorkWeight: homeWorkWeight,
                groupId: groupId
            });
        }
    }, [post]);
    var handleDataChange = useCallback(function (name, value) {
        setValues(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
    }, [setValues]);
    var onToggleLoader = function (text) {
        if (text) {
            setLoaderText(text);
        }
        setShowLoader(true);
        setTimeout(function () { return setShowLoader(false); }, 1500);
    };
    var onAddImage = useCallback(function (e, isAdditionalLoad) { return __awaiter(void 0, void 0, void 0, function () {
        var newFiles, multipleFilesCheckResult, allowed, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    newFiles = Array.from(e.target.files);
                    multipleFilesCheckResult = [];
                    if (!((newFiles === null || newFiles === void 0 ? void 0 : newFiles.length) > 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all(newFiles.map(function (img) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, uploadValidator({
                                            files: [img],
                                            toasts: toasts,
                                            isWideImageType: false,
                                            profile: profile,
                                            isLMS: isLMS
                                        })];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            });
                        }); }))];
                case 1:
                    multipleFilesCheckResult = _b.sent();
                    _b.label = 2;
                case 2:
                    if (!((files === null || files === void 0 ? void 0 : files.length) > 0)) return [3 /*break*/, 4];
                    return [4 /*yield*/, uploadValidator({
                            files: files,
                            toasts: toasts,
                            isWideImageType: false,
                            profile: profile,
                            isLMS: isLMS
                        })];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _a = true;
                    _b.label = 5;
                case 5:
                    allowed = _a;
                    if (!allowed || (multipleFilesCheckResult === null || multipleFilesCheckResult === void 0 ? void 0 : multipleFilesCheckResult.includes(false))) {
                        e.target.value = '';
                        return [2 /*return*/];
                    }
                    setTime(Date.now());
                    setTimeout(function () {
                        setFiles(isAdditionalLoad ? __spreadArray(__spreadArray([], files, true), newFiles, true) : newFiles);
                        onToggleLoader(LOADER_TEXT.add);
                    }, 0);
                    return [2 /*return*/];
            }
        });
    }); }, [values, toasts, t, images, profile, files]);
    var onTextChange = useCallback(function (id, value, mode) {
        setImages(images === null || images === void 0 ? void 0 : images.map(function (img) {
            var _a;
            if ((img === null || img === void 0 ? void 0 : img.id) === id) {
                return __assign(__assign({}, img), (_a = {}, _a[mode] = value, _a.isCaptionSetted = mode === 'caption', _a.isTextSetted = mode === 'text', _a));
            }
            return img;
        }));
    }, [images]);
    var onEsseText = useCallback(function (value) {
        setEsseText(value);
    }, [esseText]);
    var onImageTextChange = useCallback(function (ev) {
        setImageText(ev.target.value);
    }, []);
    var onSliderTextChange = useCallback(function (text, position) {
        setImageText(text);
        setImageTextPosition(position);
    }, []);
    var onImageRemove = useCallback(function (fileId) {
        var _a;
        if (isSlider) {
            var fileName_1 = ((_a = images === null || images === void 0 ? void 0 : images.find(function (_a) {
                var id = _a.id;
                return id === fileId;
            })) === null || _a === void 0 ? void 0 : _a.name) || '';
            setFiles(files === null || files === void 0 ? void 0 : files.filter(function (_a) {
                var name = _a.name;
                return name !== fileName_1;
            }));
        }
        setImages(images === null || images === void 0 ? void 0 : images.filter(function (_a) {
            var id = _a.id;
            return id !== fileId;
        }));
    }, [images, files, isSlider]);
    var onSetSortedImg = useCallback(function (list) {
        setImages(__spreadArray([], list, true));
    }, []);
    var onChooseType = useCallback(function (type) {
        setValues(function (prev) {
            if (values.maxCount === 1) {
                return __assign(__assign({}, prev), { types: prev.types[0] === type ? [] : [type] });
            }
            else {
                return __assign(__assign({}, prev), { types: prev.types.includes(type)
                        ? prev.types.filter(function (t) { return t !== type; })
                        : __spreadArray(__spreadArray([], prev.types, true), [type], false) });
            }
        });
    }, [values]);
    var onSystemType = useCallback(function (_a) {
        var label = _a.label, value = _a.value;
        if (values.nominationType === value)
            return;
        handleDataChange('nominationType', value);
    }, [values, handleDataChange]);
    var onWeightChange = useCallback(function (_a) {
        var label = _a.label, value = _a.value;
        if (values.homeWorkWeight === value)
            return;
        handleDataChange('homeWorkWeight', value);
    }, [values, handleDataChange]);
    var onGroupChange = useCallback(function (_a) {
        var label = _a.label, value = _a.value;
        if (values.groupId === value)
            return;
        handleDataChange('groupId', value);
    }, [values, handleDataChange]);
    var onHeaderChange = useCallback(function (text) {
        handleDataChange('text', text);
    }, [values]);
    var onAddText = useCallback(function (value) {
        setImageTextPosition(value);
        if (imageCaption) {
            setImageText(imageCaption);
        }
        setEditingCaption(false);
    }, [setImageTextPosition]);
    var onAddCaption = useCallback(function (value) {
        setImageCaption(value);
        setEditingCaption(false);
        setImageTextPosition('caption-bottom');
    }, [setEditingCaption, setImageTextPosition, setImageCaption]);
    var onToggleCaption = useCallback(function () {
        setEditingCaption(!editingCaption);
        setMultiLoadCaptionMode('small');
        if (imageText) {
            setImageCaption(imageText);
        }
        setImageText('');
        if (!editingCaption)
            setImageTextPosition('caption-bottom');
    }, [editingCaption]);
    var onCancel = useCallback(function () {
        setFiles([]);
        setImages([]);
        setTime(Date.now());
        setIsAddingHomework(false);
        setImageTextPosition('');
        setImageCaption('');
    }, []);
    var onCountChange = useCallback(function (count) {
        handleDataChange('maxCount', count);
    }, [values]);
    var onSlideTextChange = useCallback(function (id, text, textPosition) {
        var index = images === null || images === void 0 ? void 0 : images.findIndex(function (i) { return [i === null || i === void 0 ? void 0 : i.id, i === null || i === void 0 ? void 0 : i.postAttachmentId].includes(id); });
        var newArray = __spreadArray([], images, true);
        newArray[index] = __assign(__assign({}, newArray[index]), { text: text, textPosition: textPosition });
        setImages(newArray);
    }, [images]);
    var onAddNewPost = useCallback(function (isHomeWorkTeacherBlock) {
        var _a, _b, _c, _d, _e, _f;
        var requestData;
        var computeState = [
            { 'name': 'text', 'value': values === null || values === void 0 ? void 0 : values.text },
            { 'name': 'hm_type', 'value': values === null || values === void 0 ? void 0 : values.types.join(',') },
            { 'name': 'maxCount', 'value': ((values === null || values === void 0 ? void 0 : values.types.includes(DEFAULT_TYPE)) && (values === null || values === void 0 ? void 0 : values.types) === 1) ? IMAGE_DEFAULT_COUNT : values === null || values === void 0 ? void 0 : values.maxCount.toString() },
            { 'name': 'nominationType', 'value': (_c = (_b = (_a = values === null || values === void 0 ? void 0 : values.nominationType) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : '' },
            { 'name': 'homeWorkWeight', 'value': (_f = (_e = (_d = values === null || values === void 0 ? void 0 : values.homeWorkWeight) === null || _d === void 0 ? void 0 : _d.toString) === null || _e === void 0 ? void 0 : _e.call(_d)) !== null && _f !== void 0 ? _f : '1' },
            { 'name': 'groupId', 'value': (values === null || values === void 0 ? void 0 : values.groupId) || '' },
            { 'name': 'isMulti', value: Number(values.maxCount) > 1 ? '1' : '0' }
        ];
        if (isHomeWorkTeacherBlock) {
            requestData = __assign(__assign({}, post), { additionalInfo: computeState });
            dispatch(updateLongReadPost('', requestData));
        }
        if (tempBlock) {
            requestData = __assign(__assign({}, tempBlock), { additionalInfo: computeState });
            dispatch(updateLongReadPost('', requestData));
        }
        else {
            requestData = {
                id: null,
                title: '',
                text: '',
                color: 'light',
                imageid: '',
                lgid: longreadId,
                isFL: '',
                imgCaption: '',
                style: HOME_WORK_STUDENT_SIGN,
                num: (post === null || post === void 0 ? void 0 : post.position) + 1,
                imageData: [],
                thematic: '',
                titlePosition: '',
                projectIds: [],
                formId: '',
                formPosition: '',
                anchorText: '',
                buttons: [],
                additionalInfo: computeState
            };
            dispatch(sendHomeWorkAction(requestData));
        }
        onToggleLoader(LOADER_TEXT.create);
        setTimeout(function () {
            toasts.info(t('lms.homework.task_added'));
            dispatch(getLongReadPosts('', longreadId, sign));
            dispatch(resetHomeWorkAction());
        }, 1500);
    }, [tempBlock, values.types, values.maxCount, values.text, values.nominationType, values.homeWorkWeight, values.groupId]);
    var attachments = useMemo(function () {
        var files = [];
        if ((images === null || images === void 0 ? void 0 : images.length) === 0 || values.types.length === 0) {
            files = [];
        }
        if ((values.types.includes('slider') || values.types.includes('image')) && (images === null || images === void 0 ? void 0 : images.length)) {
            files = images === null || images === void 0 ? void 0 : images.map(function (item) {
                return {
                    text: (item === null || item === void 0 ? void 0 : item.text) || '',
                    textPosition: (item === null || item === void 0 ? void 0 : item.textPosition) || '',
                    description: (item === null || item === void 0 ? void 0 : item.caption) || '',
                    isDeleted: true,
                    postAttachmentId: '',
                    referenceId: '',
                    nominationType: '0',
                    type: 0,
                    file: {
                        fileId: "".concat(item.url),
                        containerId: 'string',
                        isNew: true,
                        type: 'string',
                        // url: data?.src,
                        url: 'string',
                        size: 'string',
                        localization: 'string'
                    }
                };
            });
        }
        return files;
    }, [images, values.types]);
    var SaveHomeWork = useCallback(function (blockType) {
        var _a;
        setIsAddingHomework(true);
        var isMultiple = (attachments === null || attachments === void 0 ? void 0 : attachments.length) > 1 && blockType === HOME_WORK_TYPES.image;
        var isSlider = blockType === HOME_WORK_TYPES.slider;
        var isImg = blockType === HOME_WORK_TYPES.image;
        var imageid = (blockType === HOME_WORK_TYPES.image && (images === null || images === void 0 ? void 0 : images.length) === 1) ? (_a = images === null || images === void 0 ? void 0 : images[0]) === null || _a === void 0 ? void 0 : _a.url : '';
        var baseInfo = isStudentPost ? post.additionalInfo : __spreadArray(__spreadArray([], post.additionalInfo, true), [
            { name: 'student_id', value: (profile === null || profile === void 0 ? void 0 : profile.accountId) || '' },
            { name: 'additionalType', value: 'student_homework' },
            { name: 'projectId', value: projectId }
        ], false);
        var filteredInfo = baseInfo.filter(function (item) { return item.name !== 'hm_type'; });
        var additionalInfo = __spreadArray(__spreadArray([
            { name: 'hm_type', value: blockType }
        ], filteredInfo, true), (Number(values.maxCount) > 1 ? [{ name: 'isMulti', value: '1' }] : []), true);
        var requestData = __assign(__assign(__assign(__assign({}, post), { attachments: attachments, imageid: imageid, lgid: longreadId }), (!isMultiple && { caption: imageCaption, text: imageText, titlePosition: imageTextPosition || 'bottom' })), { style: blockType, num: themeBlockIdx + 1, imageList: images, text: isImg ? imageText : esseText, additionalInfo: additionalInfo });
        var onSuccess = function () {
            setTimeout(function () {
                toasts.info(t('lms.homework.task_went_to_check'));
                onCancel();
                setIsAddingHomework(false);
                dispatch(getLongReadPosts('', longreadId, sign));
                dispatch(resetHomeWorkAction());
            }, 1500);
        };
        var onError = function () {
            setIsAddingHomework(false);
            toasts.info(t('lms.homework.something_went_wrong'));
        };
        urlApi().addNewHomeWorkPost(requestData, isMultiple, isSlider, onSuccess, onError);
        onToggleLoader(LOADER_TEXT.send);
    }, [
        images,
        post,
        attachments,
        profile,
        imageCaption,
        imageText,
        isStudentPost,
        longreadId,
        projectId,
        themeBlockIdx,
        esseText,
        selectedTypes
    ]);
    var handlers = useMemo(function () { return ({
        onAddImage: onAddImage,
        onImageRemove: onImageRemove,
        onChooseType: onChooseType,
        onHeaderChange: onHeaderChange,
        onSystemType: onSystemType,
        onWeightChange: onWeightChange,
        onGroupChange: onGroupChange,
        onCountChange: onCountChange,
        onSetSortedImg: onSetSortedImg,
        onAddNewPost: onAddNewPost,
        SaveHomeWork: SaveHomeWork,
        onTextChange: onTextChange,
        onImageTextChange: onImageTextChange,
        onAddText: onAddText,
        onEsseText: onEsseText,
        onSlideTextChange: onSlideTextChange,
        onSliderTextChange: onSliderTextChange,
    }); }, [
        onImageRemove,
        onAddImage,
        onChooseType,
        onHeaderChange,
        onSystemType,
        onWeightChange,
        onGroupChange,
        onCountChange,
        onSetSortedImg,
        onAddNewPost,
        SaveHomeWork,
        onTextChange,
        onImageTextChange,
        onSlideTextChange,
        onEsseText
    ]);
    var isTop = useMemo(function () {
        if (values.maxCount === 1) {
            return ((values.types[0] === HOME_WORK_TYPES.slider || values.types[0] === HOME_WORK_TYPES.image) &&
                !!(images === null || images === void 0 ? void 0 : images.length));
        }
        else if (values.maxCount > 1) {
            return ((selectedTypes.includes(HOME_WORK_TYPES.slider) || selectedTypes.includes(HOME_WORK_TYPES.image)) &&
                !!(images === null || images === void 0 ? void 0 : images.length));
        }
        return false;
    }, [values.types, images, selectedTypes]);
    var computeType = useMemo(function () { return ((values.types.includes(HOME_WORK_TYPES.image) && (images === null || images === void 0 ? void 0 : images.length) === 1) ? 'big' :
        (values.types.includes(HOME_WORK_TYPES.image) && (images === null || images === void 0 ? void 0 : images.length) > 1) ? 'multiple' : values.types.join(',')); }, [values.types, images]);
    var postDisabled = useMemo(function () {
        if (isAddingHomework)
            return true;
        var isImage = values.types.includes(HOME_WORK_TYPES.image);
        var isSlider = values.types.includes(HOME_WORK_TYPES.slider);
        if ((isImage || isSlider) && (images === null || images === void 0 ? void 0 : images.length) > 0) {
            return false;
        }
        return true;
    }, [images, isLoading, values, isAddingHomework]);
    var hideBackground = useMemo(function () { return (!isTeacher && imageTextPosition === 'caption-bottom' && !!(images === null || images === void 0 ? void 0 : images.length)); }, [imageTextPosition, isTeacher]);
    var editorToolbar = useCallback(function (type) {
        var _a;
        return (React.createElement(React.Fragment, null, isTeacher ? (React.createElement(EditorToolbar, { isLMSHomework: true, onSubmit: function () { return onAddNewPost(true); }, postBtnText: t('editor.courses.post-btn-text'), style: 'teacher-block' })) : !!(images === null || images === void 0 ? void 0 : images.length) && (React.createElement(EditorToolbar, __assign({ isLMSHomework: true, onSubmit: function () { return SaveHomeWork(type || values.types[0]); }, onAddImage: onAddImage, position: 'top', onAddText: onAddText }, ((_a = [values.types.includes(HOME_WORK_TYPES.slider)]) === null || _a === void 0 ? void 0 : _a.includes(values.types.join(','))) && { onAddSlider: function (e) { return onAddImage(e, true); } }, { onAddCaption: onToggleCaption, editingCaption: editingCaption || imageTextPosition === 'caption-bottom', postDisabled: postDisabled, fileRef: fileRef, postTextPos: imageTextPosition, multiLoadCaptionMode: multiLoadCaptionMode, style: computeType, onToggleMultiCaption: setMultiLoadCaptionMode, postBtnText: t('editor.courses.post-btn-text'), onClose: onCancel, setSliderControlsPlacer: function () {
                var sliderControlsPlacer = document.querySelector('#slider-controls-portal');
                setControlPlacer(sliderControlsPlacer);
            } })))));
    }, [
        onAddNewPost,
        SaveHomeWork,
        onAddImage,
        onAddText,
        onToggleCaption,
        onAddCaption,
        t,
        editingCaption,
        imageTextPosition,
        postDisabled,
        multiLoadCaptionMode,
        values,
        computeType,
        images,
        isTeacher,
        onCancel
    ]);
    var handleChooseType = useCallback(function (type) {
        setSelectedTypes(function (prev) { return __spreadArray(__spreadArray([], prev, true), [type], false); });
        setShowUploader(false);
        setShowAddblock(true);
    }, []);
    var handleResetType = useCallback(function () {
        setSelectedTypes([]);
        setShowUploader(true);
        setShowAddblock(false);
        setEsseText('');
    }, []);
    var handleToolbarClose = useCallback(function () {
        setShowUploader(false);
        setSelectedTypes([]);
    }, []);
    var handleStartUpload = useCallback(function () {
        setShowUploader(true);
    }, []);
    var handleAddBlockClick = useCallback(function () {
        if (uploadedHomeworksCount < values.maxCount) {
            setShowUploader(true);
            setShowAddblock(false);
        }
    }, [selectedTypes, values.maxCount, uploadedHomeworksCount]);
    var standartHomeworkRender = useMemo(function () {
        var _a;
        return (React.createElement(React.Fragment, null,
            React.createElement(ThemeBackground, { hideBackground: hideBackground },
                showLoader && React.createElement(LoaderModal, { placeholder: t("modal.loader.".concat(loaderText)) }),
                isTop && editorToolbar(values.types[0]),
                editingCaption && [HOME_WORK_TYPES.slider, HOME_WORK_TYPES.image].includes(values.types[0]) && (React.createElement(CaptionEdit, { value: imageCaption, onSubmit: function (value) { return onAddCaption(value); }, onCancel: function () { return setEditingCaption(false); } })),
                React.createElement(CourseContainer, { hidePadding: files === null || files === void 0 ? void 0 : files.length, isOwner: isTeacher }, isTeacher
                    ? React.createElement(HomeworkEdit, __assign({ text: values.text, types: values.types, count: values.maxCount, onToggleType: onChooseType, nominationType: values.nominationType, homeWorkWeight: values.homeWorkWeight, groupId: values.groupId }, handlers))
                    : React.createElement(HomeworkView, __assign({ post: post, uppy: uppy, text: values.text, imageTextPosition: imageTextPosition, imageText: imageText, textPosition: textPosition, fileRef: fileRef, count: count, maxCount: values.maxCount, src: images, types: values.types[0], isLoading: isLoading, captionMode: multiLoadCaptionMode, controlPlacer: controlPlacer, imageCaption: imageCaption, onClose: !isTeacher ? handleResetType : undefined }, handlers, { SaveHomeWork: function () { return SaveHomeWork(values.types[0]); } }))),
                !isTop && editorToolbar(values.types[0]),
                imageCaption && !((_a = ['top', 'center', 'bottom']) === null || _a === void 0 ? void 0 : _a.includes(imageTextPosition)) && (React.createElement(CaptionBlock, { colorStyle: isTeacher ? 'white' : 'lms' },
                    React.createElement(CaptionMarkdownText, { rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks(imageCaption)))))));
    }, [isTeacher, showUploader, values.types, selectedTypes, showAddblock, hideBackground, showLoader, post, images, isLoading, onAddNewPost,
        SaveHomeWork,
        onAddImage,
        onAddText,
        onToggleCaption,
        onAddCaption, handleResetType, isTop]);
    var multiHomeworkRender = useMemo(function () {
        var _a;
        return (React.createElement(React.Fragment, null,
            !isTeacher && !showUploader && values.maxCount > 1 && values.maxCount !== uploadedHomeworksCount && !selectedTypes.length && !submitDisabled && (React.createElement(MultiHomeworkStartBlock, { onStart: handleStartUpload })),
            (!isTeacher && selectedTypes.length > 0) ? (React.createElement(React.Fragment, null,
                selectedTypes.map(function (type, idx) {
                    var _a;
                    return (React.createElement("div", { key: idx, style: { marginBottom: idx !== selectedTypes.length - 1 ? 24 : 0 } },
                        React.createElement(ThemeBackground, { hideBackground: hideBackground },
                            showLoader && React.createElement(LoaderModal, { placeholder: t("modal.loader.".concat(loaderText)) }),
                            isTop && (type === HOME_WORK_TYPES.slider || type === HOME_WORK_TYPES.image) && editorToolbar(type),
                            editingCaption && (values.types.includes(HOME_WORK_TYPES.slider) || values.types.includes(HOME_WORK_TYPES.image)) && (React.createElement(CaptionEdit, { value: imageCaption, onSubmit: function (value) { return onAddCaption(value); }, onCancel: function () { return setEditingCaption(false); } })),
                            React.createElement(CourseContainer, { hidePadding: (files === null || files === void 0 ? void 0 : files.length) && (type === HOME_WORK_TYPES.slider || type === HOME_WORK_TYPES.image), isOwner: isTeacher },
                                React.createElement(HomeworkView, __assign({ post: post, uppy: uppy, text: values.text, imageTextPosition: imageTextPosition, imageText: imageText, textPosition: textPosition, fileRef: fileRef, count: count, maxCount: values.maxCount, src: images, types: [type], isLoading: isLoading, captionMode: multiLoadCaptionMode, controlPlacer: controlPlacer, imageCaption: imageCaption, onClose: handleResetType }, handlers, { SaveHomeWork: function () { return SaveHomeWork(type); } }))),
                            imageCaption && !((_a = ['top', 'center', 'bottom']) === null || _a === void 0 ? void 0 : _a.includes(imageTextPosition)) && (React.createElement(CaptionBlock, { colorStyle: isTeacher ? 'white' : 'lms' },
                                React.createElement(CaptionMarkdownText, { rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks(imageCaption)))))));
                }),
                false && ((selectedTypes.length + uploadedHomeworksCount) < values.maxCount) &&
                    React.createElement(AddBlock, { colorStyle: 'light', blockNum: selectedTypes.length, blocksLength: selectedTypes.length + 1, hideBottomAdd: true, hideTopAdd: false, theme: null, onClick: handleAddBlockClick }))) : (React.createElement(ThemeBackground, { hideBackground: hideBackground },
                showLoader && React.createElement(LoaderModal, { placeholder: t("modal.loader.".concat(loaderText)) }),
                isTop && editorToolbar(values.types[0]),
                editingCaption && values.types.includes(HOME_WORK_TYPES.slider) && (React.createElement(CaptionEdit, { value: imageCaption, onSubmit: function (value) { return onAddCaption(value); }, onCancel: function () { return setEditingCaption(false); } })),
                isTeacher
                    ? React.createElement(CourseContainer, { hidePadding: files === null || files === void 0 ? void 0 : files.length, isOwner: isTeacher },
                        React.createElement(HomeworkEdit, __assign({ text: values.text, types: values.types, count: values.maxCount, nominationType: values.nominationType, homeWorkWeight: values.homeWorkWeight, groupId: values.groupId, onToggleType: onChooseType }, handlers)))
                    : null,
                !isTop && editorToolbar(selectedTypes),
                imageCaption && !((_a = ['top', 'center', 'bottom']) === null || _a === void 0 ? void 0 : _a.includes(imageTextPosition)) && (React.createElement(CaptionBlock, { colorStyle: isTeacher ? 'white' : 'lms' },
                    React.createElement(CaptionMarkdownText, { rehypePlugins: [rehypeRaw, rehypeSanitize] }, formatLinks(imageCaption)))))),
            !isTeacher && showUploader && (React.createElement(FlexBox, { offsetBottom: 24, direction: 'column' },
                React.createElement(ToolbarDescription, null, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0431\u043B\u043E\u043A\u0430"),
                React.createElement(EditorToolbar, { style: values.types.join(','), isLMSHomework: true, onChooseType: handleChooseType, selectedTypes: selectedTypes, postBtnText: t('editor.courses.post-btn-text'), onClose: handleToolbarClose })))));
    }, [isTeacher, showUploader, values.types, selectedTypes, showAddblock, hideBackground, showLoader, post, images, isLoading, onAddNewPost,
        SaveHomeWork,
        onAddImage,
        onAddText,
        uploadedHomeworksCount,
        onToggleCaption,
        onAddCaption, handleResetType, isTop]);
    return (React.createElement(React.Fragment, null, values.maxCount === 1 ? standartHomeworkRender : multiHomeworkRender));
};
var templateObject_1;
//# sourceMappingURL=courseHomeWork.js.map